import { useEffect, useRef, useState, } from 'react';
/** Determine if element is focused via keyboard. */
export const useKeyboardFocusState = (ref) => {
    const [isKeyboardFocused, setIsKeyboardFocused,] = useState(false);
    const hadKeyboardEvent = useRef(false);
    useEffect(() => {
        const onKeyDown = () => (hadKeyboardEvent.current = true);
        const onMouseDown = () => (hadKeyboardEvent.current = false);
        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('mousedown', onMouseDown);
        const element = ref.current;
        if (!element) {
            return;
        }
        const onFocus = () => setIsKeyboardFocused(hadKeyboardEvent.current);
        const onBlur = () => setIsKeyboardFocused(false);
        element.addEventListener('focus', onFocus);
        element.addEventListener('blur', onBlur);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('mousedown', onMouseDown);
            element.removeEventListener('focus', onFocus);
            element.removeEventListener('blur', onBlur);
        };
    }, [
        ref,
    ]);
    return isKeyboardFocused;
};
